<script>
import { mapActions } from 'vuex';
import request from '@/services/request'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    components: {
        DatePicker,
    },
    props: {
        prop_edit: {
            default: true,
        }
    },
    data() {
        return {
            form: {
                contract_dues_id: '',
                id: '',
                date: '',
                pdf: '',
                xml: '',
                comment: '',
                invoice_number: '',
            },
            xml: '',
            pdf: '',
            xmlName: '',
            pdfName: '',
            send: false,
        }
    },
    methods: {
        handleFileChange(event, type) {
            const file = event.target.files[0];

            if (!file) return;

            if (type === 'xml') {
                this.form.xml = file; // guardar el archivo si lo necesitas para enviar después
                this.xmlName = file.name; // ← aquí obtienes el nombre del archivo
            }

            if (type === 'pdf') {
                this.form.pdf = file; // guardar el archivo si lo necesitas para enviar después
                this.pdfName = file.name; // ← aquí obtienes el nombre del archivo
            }

        },
        async handleSubmit() {
            this.send = true;

            const formData = new FormData();
            formData.append('contract_dues_id', this.form.contract_dues_id);
            formData.append('id', this.form.id);
            formData.append('date', this.form.date);
            formData.append('pdf', this.form.pdf);
            formData.append('xml', this.form.xml);
            formData.append('comment', this.form.comment);
            formData.append('invoice_number', this.form.invoice_number);
            let _endpoint = '/dues_bill';
            if (this.form.id != "") {
                _endpoint = `/dues_bill/${this.form.id}`;
                formData.append('_method', 'PUT');
            }

            try {
                const response = await request.postMedia(_endpoint, formData);
                Event.$emit('event-show-loadBillFormDebts');
                this.successNotification(response.data.message);
                this.resetForm();
            } catch (error) {
                this.errors = await this.errorNotification(error);
            } finally {
                this.send = false;
            }
        },
        resetForm() {
            this.form = {
                contract_dues_id: '',
                id: '',
                date: '',
                pdf: '',
                xml: '',
                comment: '',
                invoice_number: '',
            }
            this.pdf = '';
            this.xml = '';
            this.$modal.hide('addCreateBillFormDebt');
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        })
    },
    created() {
        Event.$on("event-show-addCreateBillFormDebts", (id, data) => {
            this.load = true;
            this.$modal.show('addCreateBillFormDebt');
            this.form.contract_dues_id = id;
            if (data.id) {                
                this.form.id = data.id;
                this.form.date = data.date;
                this.pdf = data.pdf;
                this.xml = data.xml;
                this.form.invoice_number = data.invoice_number;
                this.form.comment = data.comment;
                console.log(data);
            }
            this.load = false;
        });
    },
    watch: {

    }
}
</script>
<template>
    <modal name="addCreateBillFormDebt" :width="'80%'" :maxWidth="400" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="resetForm()"> <i
                class="fa-solid fa-xmark"></i> </button>

        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Facturar</h5>
        </div>
        <div class="modal-body">
            <div class="row">

                <!-- date -->
                <div class="col-6">
                    <label for="date">Fecha</label>
                    <date-picker v-model="form.date" :disabled="!prop_edit" valueType="format"></date-picker>
                    <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                </div>

                <div class="col-6">
                    <label for="date">Número de factura</label>
                    <input type="text" class="form-control" v-model="form.invoice_number">
                    <div v-if="errors && errors.invoice_number" class="text-danger">{{ errors.invoice_number[0] }}</div>
                </div>

                <!-- PDF -->
                <div class="col-6">
                    <label for="pdf">Archivo PDF</label><br>
                    <div class="custom-file" :style="pdf != '' ? 'width: 87%' : 'width: 100%'">
                        <input :disabled="!prop_edit" type="file" class="custom-file-input"
                            :class="pdf != '' ? 'pr-5' : ''" id="customFile" ref="file"
                            @change="handleFileChange($event, 'pdf')" accept="application/pdf">
                        <label class="custom-file-label text-left" for="customFile">{{ pdfName }}</label>
                    </div>
                    <a :href="`${globalUrlFiles}${pdf}`" v-if="pdf != ''" target="_blank"
                        style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-info"> <i
                            class="fa-regular fa-file"></i>
                    </a>
                    <br>
                    <div v-if="errors && errors.pdf" class="text-danger">{{ errors.pdf[0] }}</div>
                </div>

                <!-- XML -->
                <div class="col-6">
                    <label for="xml">Archivo XML</label><br>
                     <div class="custom-file" :style="xml != '' ? 'width: 87%' : 'width: 100%'">
                        <input :disabled="!prop_edit" type="file" class="custom-file-input"
                            :class="xml != '' ? 'pr-5' : ''" id="customFile" ref="file"
                            @change="handleFileChange($event, 'xml')" accept=".xml">
                        <label class="custom-file-label text-left" for="customFile">{{ xmlName }}</label>
                    </div>
                    <a :href="`${globalUrlFiles}${xml}`" v-if="xml != ''" target="_blank"
                        style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-info"> <i
                            class="fa-regular fa-file"></i>
                    </a>
                    <br>
                    <div v-if="errors && errors.xml" class="text-danger">{{ errors.xml[0] }}</div>
                </div>

                <!-- comment -->
                <div class="col-12">
                    <label for="comment">Comentario</label>
                    <textarea v-model="form.comment" rows="2" class="form-control"></textarea>
                    <div v-if="errors && errors.comment" class="text-danger">{{ errors.comment[0] }}</div>
                </div>

                <!-- submit -->
                <div class="col-12">
                    <hr>
                    
                    <button type="submit" class="btn float-right btn-outline-success" @click="handleSubmit()">
                        <spam v-if="send">
                            <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                        </spam>
                        <spam v-else>
                            <i class="fas fa-save"></i> Guardar
                        </spam>
                    </button>
                    <button type="button" @click="resetForm()" class="btn float-left btn-outline-warning">
                        <i class="fas fa-undo-alt"></i>
                        Regresar
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>